<template>
  <div id="home">
	  <div class="header">
	  		  <div class="logo-box">
	  			  <img class="logo" src="https://cdn.huimiaokeji.com/hjweb/logo.png"/>
	  		  </div>
	  		  <div class="top-menu">
	  			<div :class='curPage=="home"? "top-menu-item menu-item-active" : "top-menu-item"'  @click="gotoTop">首页</div>
	  			<div :class='curPage=="platform"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('platform-section', 'platform')">平台优势</div>
				<div :class='curPage=="product"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('product-section', 'product')">产品优势</div>
				<div :class='curPage=="cases"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('cases-section', 'cases')">合作案例</div>
	  			<div :class='curPage=="contact"? "top-menu-item menu-item-active" : "top-menu-item"' @click="scrollToView('contact-section', 'contact')">联系我们</div>
				<div :class='curPage=="news"? "top-menu-item menu-item-active" : "top-menu-item"' @click="openNews()">官方资讯</div>
	  		  </div>
	  		  <div class="login-box" @click="goUrl('https://admin.huimiaokeji.com')">
	  			  <div class="login-btn">
	  				  登录
	  			  </div>
	  		  </div>
	  </div>
    <div class="header-section">
		<div class="header-content">
			<div class="title">
				灰鲸网络
			</div>
			<div class="summary">
				属于开发者的一站式流量变现平台
			</div>
			<div class="description">
				流量变现全过程透明化，有效保证媒体的利益
			</div>
			<div class="btn-tools">
				<div class="btn" @click="goUrl('https://admin.huimiaokeji.com')">开始变现</div>
			</div>
		</div>
	</div>
	<div class="main-section">
		<div class="section-title">
			<div class="title">
				平台稳定
			</div>
			<div class="description">
				Platform stability
			</div>
		</div>
		<div class="content">
			<div class="content-item-wrap">
				<div :class="main1? 'content-item content-item-active' : 'content-item'" @mouseover="handleMouseOverMain(1)" @mouseleave="handleMouseleave(1)">
					<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/pic_decoration.png"/>
					<img class="top-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_cooperation.png"/>
					<div class="number">1000+</div>
					<div class="tips">合作媒体数</div>
				</div>
				<div :class="main2? 'content-item content-item-active' : 'content-item'" @mouseover="handleMouseOverMain(2)" @mouseleave="handleMouseleave(2)">
					<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/pic_decoration2.png"/>
					<img class="top-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_handle.png"/>
					<div class="number">200%</div>
					<div class="tips">ECPM提升</div>
				</div>
				<div :class="main3? 'content-item content-item-active' : 'content-item'" @mouseover="handleMouseOverMain(3)" @mouseleave="handleMouseleave(3)">
					<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/pic_decoration3.png"/>
					<img class="top-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_promote.png"/>
					<div class="number">60,000,000+</div>
					<div class="tips">日处理用户请求数</div>
				</div>
				<div :class="main4? 'content-item content-item-active' : 'content-item'" @mouseover="handleMouseOverMain(4)" @mouseleave="handleMouseleave(4)">
					<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/pic_decoration4.png"/>
					<img class="top-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_user.png"/>
					<div class="number">200,000,000+</div>
					<div class="tips">ECPM覆盖用户量</div>
				</div>
			</div>
		</div>
	</div>
	<div class="scene-section" id="scene-panel">
		<div class="section-title">多元化的场景服务</div>
		<div class="summary">适配各类场景，多种开发语言对接</div>
		<div class="btn-tools-box">
		<div class="btn-tools">
			<div :class="getSceneButtonClass(1)" @click="changeSceneActive(1)">开屏广告</div>
			<div :class="getSceneButtonClass(2)" @click="changeSceneActive(2)">激励视频广告</div>
			<div :class="getSceneButtonClass(3)" @click="changeSceneActive(3)">插屏广告</div>
			<div :class="getSceneButtonClass(5)" @click="changeSceneActive(5)">全屏视频广告</div>
			<div :class="getSceneButtonClass(4)" @click="changeSceneActive(4)">短视频</div>
			<div :class="getSceneButtonClass(6)" @click="changeSceneActive(6)">短剧</div>
		</div>
		</div>
		<div class="content-box">
		<div class="content" v-show="sceneActive == 1">
			<div class="content-left">
				<div class="title">
					开屏广告
				</div>
				<div class="description">
					应用启动触发，曝光黄金位置
				</div>
				<div class="horizontal-line"></div>
				<div class="go-button" @click="goUrl('https://admin.huimiaokeji.com')">立即体验</div>
			</div>
			<div class="content-right">
				<img class="right-img" src="https://cdn.huimiaokeji.com/hjweb/page_open_screen.png"/>
			</div>
		</div>
		<div class="content" v-show="sceneActive == 2">
			<div class="content-left">
				<div class="title">
					激励视频广告
				</div>
				<div class="description">
					用户可以选择观看全屏广告，期间不能强制关闭广告，从而获得一定的激励
				</div>
				<div class="horizontal-line"></div>
				<div class="go-button" @click="goUrl('https://admin.huimiaokeji.com')">立即体验</div>
			</div>
			<div class="content-right">
				<img class="right-img" src="https://cdn.huimiaokeji.com/hjweb/page_motivation_video.png"/>
			</div>
		</div>
		<div class="content" v-show="sceneActive == 3">
			<div class="content-left">
				<div class="title">
					插屏广告
				</div>
				<div class="description">
					弹出窗口展示广告，适应各类场景
				</div>
				<div class="horizontal-line"></div>
				<div class="go-button" @click="goUrl('https://admin.huimiaokeji.com')">立即体验</div>
			</div>
			<div class="content-right">
				<img class="right-img" src="https://cdn.huimiaokeji.com/hjweb/page_Insert_screen.png"/>
			</div>
		</div>
		<div class="content" v-show="sceneActive == 4">
			<div class="content-left">
				<div class="title">
					短视频
				</div>
				<div class="description">
					海量视频库 每日更新
				</div>
				<div class="horizontal-line"></div>
				<div class="go-button" @click="goUrl('https://admin.huimiaokeji.com')">立即体验</div>
			</div>
			<div class="content-right">
				<img class="right-img" src="https://cdn.huimiaokeji.com/hjweb/page_short_video.png"/>
			</div>
		</div>
		<div class="content" v-show="sceneActive == 5">
			<div class="content-left">
				<div class="title">
					全屏视频广告
				</div>
				<div class="description">
					
				</div>
				<div class="horizontal-line"></div>
				<div class="go-button" @click="goUrl('https://admin.huimiaokeji.com')">立即体验</div>
			</div>
			<div class="content-right">
				<img class="right-img" src="https://cdn.huimiaokeji.com/hjweb/page_full_screen_video.png"/>
			</div>
		</div>
		<div class="content" v-show="sceneActive == 6">
			<div class="content-left">
				<div class="title">
					短剧
				</div>
				<div class="description">
					海量视频库 每日更新
				</div>
				<div class="horizontal-line"></div>
				<div class="go-button" @click="goUrl('https://admin.huimiaokeji.com')">立即体验</div>
			</div>
			<div class="content-right">
				<img class="right-img" src="https://cdn.huimiaokeji.com/hjweb/page_short_play.png"/>
			</div>
		</div>
		</div>
	</div>
	<div class="platform-section" id="platform-section">
				<div class="title">平台优势</div>
				<div class="content-box-wrap">
				<div class="content-box" style="margin-top: 50px;">
					<div :class="platform1? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(1)">
						<div :class="platform1? 'item-title item-text-active' : 'item-title'">技术</div>
						<img class="icon" v-if="platform1" src="https://cdn.huimiaokeji.com/hjweb/icon_technology_90_2.png"/>
						<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_technology_90.png"/>
						<div :class="platform1? 'item-description item-text-active' : 'item-description'">多平台SDK竞价，高填充高收益。对接文档详尽专业，附带技术对接最佳实践</div>
						
					</div>
					<div :class="platform2? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(2)">
						<div :class="platform2? 'item-title item-text-active' : 'item-title'">能力</div>
						<img class="icon" v-if="platform2" src="https://cdn.huimiaokeji.com/hjweb/icon_ability_90_2png.png"/>
						<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_ability.png"/>
						<div :class="platform2? 'item-description item-text-active' : 'item-description'">双端：android/iOS</br/>
	开发语言：java、flutter、h5、unity3D、cocos、uniapp</div>
					</div>
					<div :class="platform3? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(3)">
						<div :class="platform3? 'item-title item-text-active' : 'item-title'">结算</div>
						<img class="icon" v-if="platform3" src="https://cdn.huimiaokeji.com/hjweb/icon_balance_90_2.png"/>
						<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_balance.png"/>
						<div :class="platform3? 'item-description item-text-active' : 'item-description'">日结，周结，月结，预付</div>
					</div>
				</div>
				</div>
				<div class="content-box-wrap">
				<div class="content-box" style="margin-top: 40px;">
					<div :class="platform4? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(4)">
						<div :class="platform4? 'item-title item-text-active' : 'item-title'">收益</div>
						<img class="icon" v-if="platform4" src="https://cdn.huimiaokeji.com/hjweb/icon_income_90_2.png"/> 
						<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_income.png"/>
						<div :class="platform4? 'item-description item-text-active' : 'item-description'">通过实时竞价，优质广告充分竞争，让每次请求获得最优收益配合自主的流量策略，灵活售卖，助力媒体取得最佳收益</div>
					</div>
					<div :class="platform5? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(5)">
						<div :class="platform5? 'item-title item-text-active' : 'item-title'">服务</div>
						<img class="icon" v-if="platform5"  src="https://cdn.huimiaokeji.com/hjweb/icon_service_90_2.png"/>
						<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_service.png"/>
						<div :class="platform5? 'item-description item-text-active' : 'item-description'">7x24小时随时在线解决您的一切疑问和顾虑</div>
					</div>
					<div :class="platform6? 'content-item item-active' : 'content-item'" @mouseover="handleMouseOver(6)">
						<div :class="platform6? 'item-title item-text-active' : 'item-title'">性能</div>
						<img class="icon" v-if="platform6" src="https://cdn.huimiaokeji.com/hjweb/icon_stable_90_2.png"/>
						<img class="icon" v-else src="https://cdn.huimiaokeji.com/hjweb/icon_stable.png"/>
						<div :class="platform6? 'item-description item-text-active' : 'item-description'">合作1000+APP高效稳定</div>
					</div>
				</div>
				</div>
			</div>
			<div class="product-section" id="product-section">
				<div class="title">产品优势</div>
				<div class="description">聚合了多家的优质广告联盟，免去媒体自己选择苦恼，评估的成本帮助您在变现业务上拓展更多成熟变现渠道</div>
				<div class="logo-table">
					<div class="logo-table-row-wrap">
					<div class="logo-table-row">
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_kwai_alliance%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_youliang_hui%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_pangolin%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_baidu_alliance%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_360_alliance%402x.png"/>
					</div>
					</div>
					<div class="logo-table-row-wrap">
					<div class="logo-table-row">
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_sigmob%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_taptap%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_huawei%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_mintegral%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_qumeng%402x.png"/>
					</div>
					</div>
					<div class="logo-table-row-wrap">
					<div class="logo-table-row">
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_channel_identification%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_w%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_am%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_oppo%402x.png"/>
						<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_youkeying%402x.png"/>
					</div>
					</div>
				</div>
			</div>
			<div class="cases-section" v-if="caseId == 1" id="cases-section">
				<div class="cases-box">
				<img class="icon-cd" src="https://cdn.huimiaokeji.com/hjweb/icon_cd_420.png"/>
				<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_online_earning_300.png"/>
				<div class="title">某网赚类APP</div>
				<div class="description">提供紧密契合的沉浸样式，满足多场景广告需求，同时视频类APP天然适配电商预算场景，可承接更多预算</div>
				<div class="number-box">
					<div class="number-item">
						<div class="number">120%</div>
						<div class="tips">单价提升</div>
					</div>
					<div class="number-item">
						<div class="number">180%</div>
						<div class="tips">收益提升</div>
					</div>
				</div>
				<div class="next-box">
					<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_upper_page_60.png" @click="toNext(3)"/>
					<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_next_page_60.png" @click="toNext(2)"/>
				</div>
				</div>
			</div>
			<div class="cases-section" v-if="caseId == 2" id="cases-section">
				<div class="cases-box">
				<img class="icon-cd" src="https://cdn.huimiaokeji.com/hjweb/icon_cd_420.png"/>
				<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_tool_300.png"/>
				<div class="title">某工具类APP</div>
				<div class="description">独家内容资源帮助提升用户留存，打破“即用即走”魔咒，更多细分行业定制场景助力适配提收</div>
				<div class="number-box">
					<div class="number-item">
						<div class="number">30%</div>
						<div class="tips">单价提升</div>
					</div>
					<div class="number-item">
						<div class="number">25%</div>
						<div class="tips">收益提升</div>
					</div>
				</div>
				<div class="next-box">
					<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_upper_page_60.png" @click="toNext(1)"/>
					<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_next_page_60.png" @click="toNext(3)"/>
				</div>
				</div>
			</div>
			<div class="cases-section" v-if="caseId == 3" id="cases-section">
				<div class="cases-box">
				<img class="icon-cd" src="https://cdn.huimiaokeji.com/hjweb/icon_cd_420.png"/>
				<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_movies_300.png"/>
				<div class="title">某影视类APP</div>
				<div class="description">通过激励视频突破收益天花板，精准买量精细运营，兼顾用户体验与转化</div>
				<div class="number-box">
					<div class="number-item">
						<div class="number">50%</div>
						<div class="tips">单价提升</div>
					</div>
					<div class="number-item">
						<div class="number">100%</div>
						<div class="tips">收益提升</div>
					</div>
				</div>
				<div class="next-box">
					<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_upper_page_60.png" @click="toNext(2)"/>
					<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_next_page_60.png" @click="toNext(1)"/>
				</div>
				</div>
			</div>
			<div class="sdk-section" id="sdk-panel">
				<div class="section-title">
					<div class="title">
						快捷接入
					</div>
					<div class="tips">Quick Access</div>
				</div>
				<div class="content-wrap">
				<div class="content">
					<div class="content-item" @mouseover="handleMouseOverSdk(1)">
						<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_sdk.jpg"/>
						<div class="item-middle">
							Mature lightweight SDK
						</div>
						<div class="item-bottom" v-if="sdk1">
							<div class="bottom-title">成熟轻量级SDK</div>
							<div class="bottom-tips">接入简单快捷</div>
						</div>
						<div class="tips" v-else>成熟轻量级SDK</div>
					</div>
					<div class="content-item" @mouseover="handleMouseOverSdk(2)">
						<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_detail.jpg"/>
						<div class="item-middle">
							Document details
						</div>
						<div class="item-bottom" v-if="sdk2">
							<div class="bottom-title">文档详细</div>
							<div class="bottom-tips">对接文档详尽专业，附带技术对接最佳实践</div>
						</div>
						<div class="tips" v-else>文档详细</div>
					</div>
				</div>
				</div>
			</div>
			<div class="step-section" id="step-panel">
				<div class="step-title">
					一站式接入 快速方便
				</div>
				<div class="step-summary">
					快速入驻，对接更便利合作流程更简单
				</div>
				<div class="step-content">
					<div class="content-box">
						<div class="step-box-one">
							<div class="step-one step-one-active" style="margin-right: 60px;">
								<div class="step-text">
									<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_communication.png"/>
									<div class="description">沟通合作</div>
								</div>
							</div>
							<div :class="step3? 'step-one step-one-active' : 'step-one'" style="margin-right: 60px;" @mouseover="handleMouseOverStep(3)">
								<div class="step-text">
									<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_technology.png"/>
									<div class="description">技术对接</div>
								</div>
							</div>
							<div :class="step5? 'step-one step-one-active' : 'step-one'" @mouseover="handleMouseOverStep(5)">
								<div class="step-text">
									<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_go_live.png"/>
									<div class="description">发版上线</div>
								</div>
							</div>
						</div>
						<div class="step-line-box">
							<div class="step-line-one"></div>
							<div class="step-icon step-icon-active">1</div>
							<div class="step-line-two"></div>
							<div :class="step2? 'step-icon step-icon-active' : 'step-icon' " @mouseover="handleMouseOverStep(2)">2</div>
							<div class="step-line-two"></div>
							<div :class="step3? 'step-icon step-icon-active' : 'step-icon' " @mouseover="handleMouseOverStep(3)">3</div>
							<div class="step-line-two"></div>
							<div :class="step4? 'step-icon step-icon-active' : 'step-icon' " @mouseover="handleMouseOverStep(4)">4</div>
							<div class="step-line-two"></div>
							<div :class="step5? 'step-icon step-icon-active' : 'step-icon' " @mouseover="handleMouseOverStep(5)">5</div>
							<div class="step-line-one"></div>
						</div>
						<div class="step-box-two">
							<div :class="step2? 'step-two step-two-active' : 'step-two'" style="margin-left: 210px;margin-right: 60px;">
								<div class="step-text" style="margin-top: 50px;" @mouseover="handleMouseOverStep(2)">
									<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_data.png"/>
									<div class="description">提交资料</div>
								</div>
							</div>
							<div :class="step4? 'step-two step-two-active' : 'step-two'" @mouseover="handleMouseOverStep(4)">
								<div class="step-text" style="margin-top: 50px;">
									<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_test.png"/>
									<div class="description">测试验收</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="product-section2" id="contact-section">
				<!-- <div class="section2-title1">一站式APP广告变现平台</div> -->
				<div class="content">
					<!-- <el-row style="margin-top: 50px;">
						<el-col :span="11">
							<el-input v-model="form.name" placeholder="输入姓名"></el-input>
						</el-col>
						<el-col :span="2">
							&nbsp;
						</el-col>
						<el-col :span="11">
							<el-input v-model="form.phone" placeholder="输入手机号"></el-input>
						</el-col>
					</el-row>
					<el-input v-model="form.projectName" placeholder="输入项目名称" style="margin-top: 20px;"></el-input>
					<el-input v-model="form.companyName" placeholder="输入公司名称" style="margin-top: 20px;"></el-input>
					<div class="section2-btn">立即咨询</div>
					<div class="section2-line"></div> -->
					<div class="section2-title2">扫码联系我们</div>
					<div class="card-box">
						<div class="card-panel">
							<div class="card-panel-qrcode">
								<img class="qrcode-icon" src="https://cdn.huimiaokeji.com/hjweb/qrcode_new.jpeg"/>
							</div>
							<div class="card-panel-right">
								<div class="right-title">商务联系方式</div>
								<div class="right-rows">
									<el-row>
										<el-col :span="6">联系方式</el-col>
										<el-col :span="12">17826840773(微信同号)</el-col>
									</el-row>
									<el-row style="margin-top: 20px;">
										<el-col :span="6">电子邮箱</el-col>
										<el-col :span="12">hjwl0575@163.com</el-col>
									</el-row>
									<el-row style="margin-top: 20px;">
										<el-col :span="6">Telegram</el-col>
										<el-col :span="12">https://t.me/huijing02</el-col>
									</el-row>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
	<footer-menu></footer-menu>
  </div>
</template>

<script>
	import HeaderMenu from '../components/header-menu.vue';
	import FooterMenu from '../components/footer-menu.vue';
export default {
	name:'home',
	components: {
		HeaderMenu,
		FooterMenu
	},
	data() {
		return {
			curPage: 'home',
			curSuperiorityItem:1,
			productActive:1,
			sceneActive:1,
			main1: true,
			main2: false,
			main3: false,
			main4: false,
			sdk1: false,
			sdk2: false,
			step2: false,
			step3: false,
			step4: false,
			step5: false,
			platform1: false,
			platform2: false,
			platform3: false,
			platform4: false,
			platform5: false,
			platform6: false,
			name: null,
			phone: null,
			projectName: null,
			companyName: null,
			caseId: 1
		}
	},
	created() {
	  document.title = '灰鲸网络-首页';
	},
  methods: {
	  navTo(url, page) {
	  	this.curPage = page;
	  	this.$router.push({ path:url})
	  },
	  toNext(caseId) {
	  	this.caseId = caseId;
	  },
	  handleMouseOver(flag) {
	  		if (flag == 1) {
	  			this.platform1 = true;
	  		} else if (flag == 2) {
	  			this.platform2 = true;
	  		} else if (flag == 3) {
	  			this.platform3 = true;
	  		} else if (flag == 4) {
	  			this.platform4 = true;
	  		} else if (flag == 5) {
	  			this.platform5 = true;
	  		} else if (flag == 6) {
	  			this.platform6 = true;
	  		}
	  },
	  handleMouseOverStep(flag) {
	  		if (flag == 2) {
	  			this.step2 = true;
	  		} else if (flag == 3){
	  			this.step3 = true;
				this.step2 = true;
	  		} else if (flag == 4){
	  			this.step4 = true;
				this.step3 = true;
				this.step2 = true;
	  		} else if (flag == 5){
	  			this.step5 = true;
				this.step4 = true;
				this.step3 = true;
				this.step2 = true;
	  		}
	  },
	  handleMouseOverSdk(flag) {
		if (flag == 1) {
			this.sdk1 = true;
		} else {
			this.sdk2 = true;
		}
	  },
	  handleMouseOutSdk(flag) {
		  if (flag == 1) {
		  	this.sdk1 = false;
		  } else {
		  	this.sdk2 = false;
		  }
	  },
	  handleMouseOverMain(flag) {
		  if (flag == 1) {
			  this.main1 = true;
		  } else if (flag == 2) {
			this.main2 = true;
		} else if (flag == 3) {
			this.main3 = true;
		} else if (flag == 4) {
			this.main4 = true;
		}
	  },
	  handleMouseleave(flag) {
		  if (flag == 1) {
		  	this.main1 = false;
		  } else if (flag == 2) {
		  	this.main2 = false;
		  } else if (flag == 3) {
		  	this.main3 = false;
		  } else if (flag == 4) {
		  	this.main4 = false;
		  }
	  },
	  gotoTop() {
		location.reload();
	  },
	  goUrl(url){
		   window.open(url);
	  },
	  getSceneButtonClass(flag) {
		  let result = "button";
		  if (this.sceneActive == flag) {
			result += " button-active";
		  }
		  return result;
	  },
	  getButtonClass(flag) {
		  let result = "button";
		  if (this.productActive == flag) {
			  result += " button-active";
		  }
		  return result;
	  },
	  changeSceneActive(flag) {
	  		  this.sceneActive = flag;
	  },
	  changeProductActive(flag) {
		  this.productActive = flag;
	  },
	  changeActiveItem(e, flag) {
		  this.curSuperiorityItem = flag;
		  console.log("#######flag",flag)
	  },
	  scrollToView(id, page) {
		  this.curPage = page;
		  let element = document.getElementById(id);
		  element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
	  },
	  openNews() {
		  this.curPage = "news";
		  this.goUrl(window.location.origin + "/#/news");
	  }
  }
}
</script>

<style lang="less">
#home {
  background-color: #FFFFFF;
  .header {
	  width: 100%;
	  z-index: 999999;
	  position: fixed;
	  left: 0;
	  top:0 ;
  	  display: flex;
  	   height: 80px;
	   background-color: #FFFFFF;
  	  .logo-box {
  		  flex:1;
  		  display: flex;
  		  align-items: center;
  		  .logo {
  			margin-left: 40px;
  			width: 205px;	
  			height: 30px;
  		  }
  	  }
  	  .top-menu{
  		  flex:1;
  			  font-size: 14px;
  			  font-family: PingFangSC, PingFang SC;
  			  font-weight: 400;
  			  color: #333333;
  			  line-height: 80px;
  			  display: flex;
  			  justify-content: space-between;
  			  padding-left: 200px;
  			  padding-right: 200px;
  			  // padding-left: 60%;
  			  .top-menu-item {
  				  // margin-right: 38px;
  				  cursor: pointer;
  			  }
  			  .menu-item-active {
  				  color: #0B00B5;
  				  font-weight: bold;
  			  }
  	  }
  	  .login-box {
  		  flex:1;
  		  cursor: pointer;
  		  .login-btn {
  			  width: 120px;
  			  height: 80px;
  			  background: #0B00B5;
  			  font-family: PingFangSC, PingFang SC;
  			  font-weight: bold;
  			  font-size: 14px;
  			  color: #FFFFFF;
  			  line-height: 80px;
  			  text-align: center;
  			  font-style: normal;
  			  float: right;
  		  }
  	  }
    }
  .header-section {
	  margin-top: 80px;
  	  height: 820px;
  	  background: url(https://cdn.huimiaokeji.com/hjweb/bg_banner_2.jpg) no-repeat;
  	  background-size: 100% 820px;
  	  width:100%;
	  .header-content {
				padding-left: 16%;
				padding-top: 200px;
	  		  .title {
				  font-family: PingFangSC, PingFang SC;
				  font-weight: bold;
				  font-size: 34px;
				  color: #0B00B5;
				  line-height: 34px;
				  text-align: left;
				  font-style: normal;
	  		  }
			  .summary{
				  margin-top: 30px;
				  font-family: PingFangSC, PingFang SC;
				  font-weight: bold;
				  font-size: 34px;
				  color: #0B00B5;
				  line-height: 34px;
				  text-align: left;
				  font-style: normal;
			  }
			  .description {
				  margin-top: 40px;
				  font-family: PingFangSC, PingFang SC;
				  font-weight: 400;
				  font-size: 22px;
				  color: #333333;
				  line-height: 22px;
				  text-align: left;
				  font-style: normal;
			  }
			  .btn-tools{
			  			  text-align: center;
			  			  margin-top: 120px;
			  			  .btn{
			  				  width: 164px;
			  				  height: 60px;
			  				  background: #0B00B5;
			  				  font-family: PingFangSC, PingFang SC;
			  				  font-weight: bold;
			  				  font-size: 16px;
			  				  color: #FFFFFF;
			  				  line-height: 60px;
			  				  text-align: center;
			  				  font-style: normal;
							  cursor: pointer;
			  			  }
			  }
	  	  }
		  
  }
  .main-section{
		margin-top: 50px;
		.section-title{
			text-align: center;
			// display: flex;
			// justify-content:center;
			// .title-bg{
			// 	width: 260px;
			// 	height: 60px;
			// 	background: url(http://cdn.huimiaokeji.com/huijing/title-bg.jpg) no-repeat;
			// 	background-size: 260px 42px;
			// 	margin-bottom: 52px;
				.title {
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 26px;
					color: #0B00B5;
					line-height: 26px;
					text-align: center;
					font-style: normal;
				}
				.description {
					margin-top: 20px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 22px;
					color: #8F9699;
					line-height: 22px;
					text-align: center;
					font-style: normal;
					text-transform: uppercase;
				}
			// }
		}
		.content{
			display: flex;
			justify-content:center;
			padding-left: 120px;
			padding-right: 120px;
			margin-top: 50px;
			.content-item-wrap {
				display: flex;
			.content-item{
					position:relative;
					// background: #0B00B5;
					background: #8399c2;
					opacity: 0.9;
					width: 270px;
					height: 402px;
					// text-align: center;
					.icon {
						position:absolute;
						width: 270px;
						height: 402px;
						left: 0;
						top: 0;
					}
					.top-icon {
						width: 62px;
						height: 62px;
						margin-top: 80px;
						margin-left: 40px;
					}
					.number {
						font-family: PingFangSC, PingFang SC;
						font-weight: bold;
						font-size: 28px;
						color: #FFFFFF;
						line-height: 28px;
						text-align: left;
						font-style: normal;
						margin-left: 40px;
						margin-top: 106px;
					}
					.tips {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 16px;
						color: #F3F7FF;
						line-height: 16px;
						text-align: left;
						font-style: normal;
						margin-left: 40px;
						margin-top: 30px;
					}
					&:not(:last-child) {
						margin-right: 40px;
					}
				}
				.content-item-active {
					background: #0B00B5;
					opacity: 1;
				}
			}
			
		}
		.product-content{
			width: 66%;
			margin-left: 17%;
			display: flex;
			.product-content-left{
				flex:1;
				padding-left: 10px;
				.button{
					width: 171px;
					height: 48px;
					background: #FFFFFF;
					box-shadow: 0px 0px 7px 0px rgba(113,147,255,0.44);
					border-radius: 6px 6px 6px 6px;
					opacity: 1;
					font-size: 20px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					line-height: 48px;
					text-align: center;
					margin-bottom: 58px;
					cursor: pointer;
				}
				.button-active{
					background: #4E70FB;
					color: #FFFFFF;
				}
			}
			.product-content-right{
				flex:3;
				.description{
					font-size: 18px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					line-height: 28px;
				}
				.product-1{
					margin-top: 34px;
					width: 100%;
					height: 120px;
				}
				.left-right-panel{
					display: flex;
					.left-item{
						flex:1;
						font-size: 18px;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 28px;
					}
					.right-item{
						flex:2;
						.right-img{
							width: 100%;
							height: 280px;
						}
					}
				}
			}
		}
  }
  .superiority-section{
	  width: 100%;
	  height: 560px;
	  margin-top: 80px;
	  background: url(http://cdn.huimiaokeji.com/huijing/superiority-bg.jpg) no-repeat;
	  background-size: 100% 560px;
	  .section-title{
		  font-size: 30px;
		  font-family: PingFang SC-Medium, PingFang SC;
		  font-weight: 500;
		  color: #FFFFFF;
		  line-height: 120px;
		  text-align: center;
		}
		.content{
			display: flex;
			justify-content:center;
			margin-top: 70px;
			.content-item-expand {
				width: 350px;
				height: 273px;
				background: #3A42A9;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				margin-right: 10px;
				.item-icon{
					margin-top: 100px;
					width: 86px;
					height: 63px;
				}
			}
			.content-item-retract{
				width: 100px;
				height: 273px;
				background: #3A42A9;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				text-align: center;
				margin-right: 10px;
				.item-icon{
					margin-top: 128px;
					width: 86px;
					height: 63px;
				}
			}
			.item-bg-1{
				background: url(http://cdn.huimiaokeji.com/huijing/item-bg-1.jpg) no-repeat;
				background-size: 350px 273px;
			}
			.item-retract-bg-1{
				background: url(http://cdn.huimiaokeji.com/huijing/item-retract-bg-1.png) no-repeat;
				background-size: 100px 273px;
			}
			.item-bg-2{
				background: url(http://cdn.huimiaokeji.com/huijing/item-bg-2.jpg) no-repeat;
				background-size: 350px 273px;
			}
			.item-retract-bg-2{
				background: url(http://cdn.huimiaokeji.com/huijing/item-retract-bg-2.png) no-repeat;
				background-size: 100px 273px;
			}
			.item-bg-3{
				background: url(http://cdn.huimiaokeji.com/huijing/item-bg-3.jpg?v=230929) no-repeat;
				background-size: 350px 273px;
			}
			.item-retract-bg-3{
				background: url(http://cdn.huimiaokeji.com/huijing/item-retract-bg-3.png) no-repeat;
				background-size: 100px 273px;
			}
			.item-bg-4{
				background: url(http://cdn.huimiaokeji.com/huijing/item-bg-4.jpg) no-repeat;
				background-size: 350px 273px;
			}
			.item-retract-bg-4{
				background: url(http://cdn.huimiaokeji.com/huijing/item-retract-bg-4.png) no-repeat;
				background-size: 100px 273px;
			}
			.item-bg-5{
				background: url(http://cdn.huimiaokeji.com/huijing/item-bg-5.jpg) no-repeat;
				background-size: 350px 273px;
			}
			.item-retract-bg-5{
				background: url(http://cdn.huimiaokeji.com/huijing/item-retract-bg-5.png) no-repeat;
				background-size: 100px 273px;
			}
			.item-bg-6{
				background: url(http://cdn.huimiaokeji.com/huijing/item-bg-6.jpg) no-repeat;
				background-size: 350px 273px;
			}
			.item-retract-bg-6{
				background: url(http://cdn.huimiaokeji.com/huijing/item-retract-bg-6.png) no-repeat;
				background-size: 100px 273px;
			}
			.title{
				font-size: 18px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 28px;
				padding-left: 25px;
			}
			.description{
				width: 75%;
				padding-top:15px;
				font-size: 12px;
				padding-left: 25px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 20px;
			}
		}
		
  }
  .scene-section{
  	  width: 100%;
  	  height: 820px;
  	  margin-top: 50px;
  	  background: url(https://cdn.huimiaokeji.com/hjweb/bg_diversification.jpg) no-repeat;
  	  background-size: 100% 820px;
  	  .section-title{
		  padding-top: 100px;
  		  font-family: PingFangSC, PingFang SC;
  		  font-weight: bold;
  		  font-size: 26px;
  		  color: #FFFFFF;
  		  line-height: 26px;
  		  text-align: center;
  		  font-style: normal;
  		}
		.summary{
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 22px;
			color: rgba(255,255,255,0.5);
			line-height: 22px;
			text-align: center;
			font-style: normal;
			text-transform: uppercase;
			margin-top: 20px;
		}
		.btn-tools-box {
			display: flex;
			justify-content:center;
			.btn-tools{
				display: flex;
				justify-content:space-between;
				margin-top: 50px;
				margin-bottom: 60px;
				.button{
					// width: 140px;
					height: 40px;
					padding-left: 20px;
					padding-right: 20px;
					border-radius: 22px;
					border: 1px solid rgba(254,254,254,0.5);
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 40px;
					text-align: center;
					font-style: normal;
					cursor: pointer;
					&:not(:last-child) {
					    margin-right: 40px;  
					}
				}
				.button-active{
					background: #FFFFFF;
					color: #0B00B5;
					font-weight: bold;
				}
			}
		}
		.content-box {
			display: flex;
			justify-content: center;
		.content{
			display: flex;
			.content-left{
				width: 600px;
				padding-left: 30px;
				.title{
				  margin-top: 50px;
				  font-family: PingFangSC, PingFang SC;
				  font-weight: bold;
				  font-size: 24px;
				  color: #FFFFFF;
				  line-height: 24px;
				  font-style: normal;
				}
				.description{
					margin-top: 40px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 20px;
					text-align: justify;
					font-style: normal;
				}
				.horizontal-line {
					width: 20px;
					height: 2px;
					background: #FFFFFF;
					margin-top: 60px;
				}
				.go-button{
					margin-top: 96px;
					width: 164px;
					height: 60px;
					border: 1px solid #FFFFFF;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 16px;
					color: #FFFFFF;
					line-height: 60px;
					font-style: normal;
					text-align: center;
					cursor: pointer;
				}
			}
			.content-right{
				display: flex;
				justify-content: center;
				.right-img{
					width: 186px;
					height: 402px;
				}
			}
		}
		}
	}
	.case-section{
		margin-top: 50px;
		.section-title{
			text-align: center;
			display: flex;
			justify-content:center;
			.title-bg{
				width: 260px;
				height: 60px;
				background: url(http://cdn.huimiaokeji.com/huijing/title-bg.jpg) no-repeat;
				background-size: 260px 42px;
				margin-bottom: 52px;
				.title {
					font-size: 30px;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
					line-height: 68px;
				}
			}
		}
		.content {
			display: flex;
			.case-left{
				flex:3;
				padding-left: 16%;
				.left-icon{
					width: 300px;
					height: 285px;
					margin-bottom: 20px;
				}
				.label-btn-tools{
					padding-left: 9%;
					.label-btn{
						width: 180px;
						height: 63px;
						background: url(http://cdn.huimiaokeji.com/huijing/label-btn.jpg) no-repeat;
						background-size: 180px 63px;
						margin-top: 20px;
						font-size: 18px;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #4E70FB;
						line-height: 63px;
						text-align: center;
					}
				}
			}
			.case-right{
				flex:5;
				.case-right-item{
					display: flex;
					width: 80%;
					height: 168px;
					background: #FFFFFF;
					box-shadow: 0px 0px 7px 0px rgba(113,147,255,0.44);
					border-radius: 10px 10px 10px 10px;
					opacity: 1;
					padding-top: 22px;
					padding-left: 22px;
					margin-bottom: 30px;
					.case-right-item-left{
						flex:1;
						display: flex;
						justify-content: center;
						align-items: center;
						.item-left-icon{
							
						}
					}
					.case-right-item-right{
						flex:5;
						.item-right-title {
							font-size: 18px;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							line-height: 50px;
						}
						.item-right-description{
							font-size: 14px;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							line-height: 28px;
						}
						.item-right-bottom{
							display: flex;
							flex-wrap: wrap;
							margin-top: 11px;
							.bottom-label{
								font-size: 14px;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #000000;
								margin-right: 20px;
								line-height: 25px;
							}
							.bottom-label-big{
								font-size: 18px;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #4E70FB;
								margin-right: 15px;
								line-height: 20px;
							}
							.bottom-icon{
								margin-right: 45px;
								height: 18px;
							}
						}
					}
				}
			}
		}
	}
	.sdk-section{
		  width: 100%;
		  height: 650px;
		  background: #F3F7FF;
		  .section-title{
			padding-top: 50px;
		  	text-align: center;
		  	// justify-content:center;
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 26px;
				color: #0B00B5;
				line-height: 26px;
				text-align: center;
				font-style: normal;
			}
			.tips {
				margin-top: 20px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 22px;
				color: #8F9699;
				line-height: 22px;
				text-align: center;
				font-style: normal;
				text-transform: uppercase;
			}
		  }
		  .content-wrap {
			  display: flex;
			  justify-content: center;
		  .content{
		  	display: flex;
		  	margin-top: 50px;
		  	.content-item{
		  		width: 580px;
		  		height: 402px;
				position:relative;
				background: #0B00B5;
		  		// text-align: center;
		  		.icon {
					position:absolute;
					top: 0;
					left: 0;
		  			width: 580px;
		  			height: 402px;
		  		}
		  		.item-middle{
					position:absolute;
		  			font-family: PingFangSC, PingFang SC;
		  			font-weight: bold;
		  			font-size: 24px;
		  			color: #00F5FF;
		  			line-height: 24px;
		  			text-align: left;
		  			font-style: normal;
		  			text-transform: uppercase;
					top: 40px;
					left: 40px;
		  		}
				.tips {
					position:absolute;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 18px;
					color: #FFFFFF;
					line-height: 18px;
					text-align: left;
					font-style: normal;
					left: 40px;
					bottom: 40px;
				}
		  		.item-bottom{
		  			width: 580px;
					height: 132px;
					background: rgba(0,245,255,0.9);
					opacity: 0.8;
					position:absolute;
					bottom: 0;
					left: 0;
					.bottom-title {
						font-family: PingFangSC, PingFang SC;
						font-weight: bold;
						font-size: 18px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
						margin-top: 40px;
						margin-left: 40px;
					}
					.bottom-tips {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #2E4447;
						line-height: 14px;
						text-align: left;
						font-style: normal;
						margin-top: 20px;
						margin-left: 40px;
					}
		  		}
				&:not(:last-child) {
					margin-right: 40px;
				}
		  	}
		  }
		  }
	}
	.step-section{
		height: 600px;
		text-align: center;
		.step-title{
			padding-top: 50px;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 26px;
			color: #0B00B5;
			line-height: 26px;
			font-style: normal;
		}
		.step-summary {
			margin-top: 20px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 22px;
			color: #8F9699;
			line-height: 22px;
			font-style: normal;
			text-transform: uppercase;
		}
		.step-content{
			display: flex;
			justify-content:center;
			margin-top: 50px;
			.content-box {
				width: 1200px;
				height: 352px;
				.step-box-one {
					display: flex;
					.step-one {
						width: 360px;
						height: 120px;
						background: url(https://cdn.huimiaokeji.com/hjweb/icon_step_default1.png) no-repeat;
						background-size: 360px 120px;
					}
					.step-one-active {
						background: url(https://cdn.huimiaokeji.com/hjweb/icon_moving_in1.png) no-repeat;
						background-size: 360px 120px;
					}
				}
				.step-box-two {
					display: flex;
					margin-top: 35px;
					.step-two {
						width: 360px;
						height: 120px;
						background: url(https://cdn.huimiaokeji.com/hjweb/icon_step_default2.png) no-repeat;
						background-size: 360px 120px;
					}
					.step-two-active {
						background: url(https://cdn.huimiaokeji.com/hjweb/icon_step2.png) no-repeat;
						background-size: 360px 120px;
					}
				}
				.step-line-box {
					height: 42px;
					margin-top: 35px;
					display: flex;
					align-items: center;
					.step-line-one {
						width: 159px;
						height: 2px;
						background: #F3F7FF;
					}
					.step-line-two {
						width: 168px;
						height: 2px;
						background: #F3F7FF;
					}
					.step-icon {
						width: 42px;
						height: 42px;
						background: #FFFFFF;
						border: 1px solid #7E99C6;
						color: #7E99C6;
						border-radius: 50%;
						font-family: PingFangSC, PingFang SC;
						font-weight: bold;
						font-size: 18px;
						line-height: 42px;
						text-align: center;
						font-style: normal;
					}
					.step-icon-active {
						border: 1px solid #0B00B5;
						color: #0B00B5;
					}
				}
			}
		}
		.step-text {
			height: 40px;
			padding-left: 84px;
			margin-top: 30px;
			display: flex;
			.icon {
				width: 45px;
				height: 40px;
			}
			.description {
				margin-left: 20px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 20px;
				color: #FFFFFF;
				line-height: 40px;
				text-align: left;
				font-style: normal;
			}
		}
	}
	.join-section{
		  width: 100%;
		  height: 400px;
		  margin-top: 80px;
		  background: url(http://cdn.huimiaokeji.com/huijing/join-bg.png) no-repeat;
		  background-size: 100% 400px;
		  /* padding-top:100px; */
		  text-align: center;
		  .section-title{
		  	text-align: center;
		  	display: flex;
		  	justify-content:center;
			padding-top: 100px;
		  	.title-bg{
		  		width: 500px;
		  		height: 60px;
		  		background: url(http://cdn.huimiaokeji.com/huijing/join-title-bg.png) no-repeat;
		  		background-size: 260px 42px;
				background-position: center center;
		  		margin-bottom: 52px;
		  		.title {
		  			font-size: 30px;
		  			font-family: PingFang SC-Medium, PingFang SC;
		  			font-weight: 500;
		  			color: #333333;
		  			line-height: 80px;
		  		}
		  	}
		  }
		  .summary{
			  font-size: 16px;
			  font-family: PingFang SC-Regular, PingFang SC;
			  font-weight: 400;
			  color: #333333;
			  line-height: 23px;
			  text-align: center;
		  }
		  .btn-tools{
			  display: flex;
			  justify-content:center;
			  text-align: center;
			  margin-top: 40px;
			  .btn{
				  width: 230px;
				  height: 70px;
				  background: #4E70FB;
				  border-radius: 10px 10px 10px 10px;
				  opacity: 1;
				  font-size: 24px;
				  font-family: PingFang SC-Medium, PingFang SC;
				  font-weight: 500;
				  color: #FFFFFF;
				  line-height: 70px;
				  cursor: pointer;
				  text-align: center;
			  }
		  }
	}
	.platform-section{
			  height: 720px;
			  background: #F3F7FF;
			  .title {
				  padding-top:50px;
				  font-family: PingFangSC, PingFang SC;
				  font-weight: bold;
				  font-size: 34px;
				  color: #0B00B5;
				  line-height: 34px;
				  text-align: center;
				  font-style: normal;
			  }
			  .content-box-wrap {
				  display: flex;
				  justify-content: center;
			  .content-box {
				  display: flex;
				  .content-item {
					  width: 373px;
					  height: 223px;
					  background: #FFFFFF;
					  position: relative;
					  .item-title {
						  padding-top: 40px;
						  padding-left: 40px;
						  font-family: PingFangSC, PingFang SC;
						  font-weight: bold;
						  font-size: 24px;
						  color: #333333;
						  line-height: 24px;
						  text-align: left;
						  font-style: normal;
					  }
					  .item-description {
						  position:absolute;
						  width: 293px;
						  left: 40px;
						  top: 94px;
						  font-family: PingFangSC, PingFang SC;
						  font-weight: 400;
						  font-size: 16px;
						  color: #666666;
						  line-height: 20px;
						  text-align: justify;
						  font-style: normal;
					  }
					  .icon {
						  position:absolute;
						  bottom: 0;
						  right: 0;
						  width: 90px;
						  height: 90px;
					  }
					  .item-text-active {
					  				  color: #FFFFFF;
					  }
					  &:not(:last-child) {  
						  margin-right: 41px;
					  }
				  }
				  .item-active {
					  background: #0B00B5;
				  }
				  
			  }
			  }
	}
	.product-section {
		width: 100%;
		height: 620px;
		background: #F3F7FF;
		.title {
			// padding-top: 50px;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 34px;
			color: #0B00B5;
			line-height: 34px;
			text-align: center;
			font-style: normal;
		}
		.description {
			margin-top: 40px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 22px;
			color: #333333;
			line-height: 22px;
			text-align: center;
			font-style: normal;
		}
		.logo-table {
			width: 100%;
			padding-top: 50px;
			.logo-table-row-wrap {
				display: flex;
				justify-content: center;
				.logo-table-row {
					padding-left: 10%;
					padding-right: 10%;
					display: flex;
					justify-content: space-between;
					margin-bottom: 40px;
					.logo-item {
						width: 208px;
						height: 106px;
						&:not(:last-child) {
							margin-right: 40px;
						}
					}
				}
			}
		}
	}
	.product-section2 {
		height: 450px;
		.section2-title1 {
			padding-top: 30px;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 26px;
			color: #0B00B5;
			line-height: 26px;
			text-align: center;
			font-style: normal;
		}
		.content {
			width: 80%;
			margin-left: 10%;
		}
		.el-input__inner {
			background-color: #F3F7FF;
			height: 66px;
			line-height: 66px;
		}
		.section2-btn {
			height: 76px;
			background: #0B00B5;
			margin-top: 40px;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 76px;
			text-align: center;
			font-style: normal;
			cursor: pointer;
		}
		.section2-line {
			margin-top: 100px;
			width: 100%;
			height: 1px;
			background: #E6E5F7;
		}
		.section2-title2 {
			// margin-top: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 26px;
			color: #0B00B5;
			line-height: 26px;
			text-align: center;
			font-style: normal;
		}
		.card-box {
			margin-top: 50px;
			height: 314px;
			background: #F3F7FF;
			padding-left: 10%;
			padding-right: 10%;
			.card-panel {
				display: flex;
				.card-panel-qrcode {
					height: 314px;
					flex:2;
					display: flex;
					align-items: center;
					justify-content: center;
					.qrcode-icon {
						width: 194px;
						height: 265px;
					}
				}
				.card-panel-right {
					flex:3;
					.right-title {
						padding-top: 80px;
						font-family: PingFangSC, PingFang SC;
						font-weight: bold;
						font-size: 24px;
						color: #333333;
						line-height: 24px;
						text-align: left;
						font-style: normal;
					}
					.right-rows{
						margin-top: 30px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 20px;
						color: #333333;
						line-height: 20px;
						text-align: left;
						font-style: normal;
					}
				}
			}
		}
	}
	.cases-section{
		width: 100%;
		height: 670px;
		// margin-bottom: 100px;
		background: url(https://cdn.huimiaokeji.com/hjweb/bg_collaboration_cases.jpg) no-repeat;
		background-size: 100% 670px;
		display: flex;
		justify-content: center;
		.cases-box {
			width: 85%;
			position: relative;
			.icon-cd {
				position: absolute;
				bottom: 60px;
				right: 10%;
				width: 420px;
				height: 420px;
			}
			.icon {
				position: absolute;
				bottom: 370px;
				right: 13.5%;
				width: 300px;
				height: 300px;
			}
			.title {
				position: absolute;
				top: 100px;
				left: 120px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 34px;
				color: #0B00B5;
				line-height: 34px;
				text-align: left;
				font-style: normal;
			}
			.description {
				position: absolute;
				top: 214px;
				left: 120px;
				width: 600px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
				line-height: 30px;
				text-align: justify;
				font-style: normal;
			}
			.number-box {
				position: absolute;
				top: 304px;
				left: 120px;
				display: flex;
				width: 424px;
				.number-item {
					flex: 1;
					.number {
						font-family: DingTalk, DingTalk;
						font-weight: normal;
						font-size: 40px;
						color: #5511FF;
						line-height: 40px;
						text-align: left;
						font-style: normal;
					}
					.tips {
						margin-top: 20px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 16px;
						color: #3E5979;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}
				}
			}
			.next-box {
				// width: 100%;
				position: absolute;
				height: 60px;
				left: 120px;
				bottom: 200px;
				display: flex;
				.next-box-icon {
					width: 60px;
					height: 60px;
					margin-right: 40px;
					cursor: pointer;
				}
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue